module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f2457825850317e66ef2128504613c30.svg";